import {Directive, ElementRef, EventEmitter, Input, Output} from "@angular/core";

const $ = require('jquery');
require('icheck');

@Directive({
    selector: '[i-checkbox]'
})
export class ICheckBoxDirective { //TODO implement ControlValueAccessor

    @Output() check: EventEmitter<boolean> = new EventEmitter();
    @Input() checked: boolean = false;

    constructor(private el: ElementRef) {
    }

    ngOnInit() {
        window['jQuery'] = $;

        setTimeout(() => {
            $(this.el.nativeElement).iCheck({
                checkboxClass: 'icheckbox_flat-green'
            }).on('ifChecked', () => {
                this.check.emit(true)
            }).on('ifUnchecked', () => {
                this.check.emit(false)
            });

            if (this.checked) {
                $(this.el.nativeElement).iCheck('check');
            }
        }, 5);
    }
}


// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/angular-router-loader/src!./src/common/components/icheckbox/i.checkbox.directive.ts